export default class Feedback {
    constructor() {
        this.listeners = [];
    }

    bindCloseButtons() {
        this.cleanup();
        const closeButtons = document.querySelectorAll('.feedback-close-btn');
        closeButtons.forEach(button => {
            const listener = () => {
                const wrapper = button.closest('.feedback-wrapper');
                if (wrapper) {
                    wrapper.style.display = 'none';
                }
            };
            button.addEventListener('click', listener);
            this.listeners.push({element: button, listener});
        });
    }

    cleanup() {
        this.listeners.forEach(({element, listener}) => {
            element.removeEventListener('click', listener);
        });
        this.listeners = [];
    }
}